import {useTranslation} from "react-i18next";
import {useEffect, useState, useRef, useMemo} from "react";
import {useParams} from "react-router-dom";
import {FontAwesomeIcon} from "@fortawesome/react-fontawesome";

import axiApi from "ApiCaller";
import navs from "../navs";
import DateUtils from "core/utils/DateUtils";
import NavBreadcrumb from "components/NavBreadcrum";
import MapAssetAndDevicesJS from "components/maps/MapAssetAndDevicesJS";
import ConditionalRender from "components/ConditionalRender";
import {Asset} from "site-apps/assets/AssetModels";
import ParamsAsset from "./waste/ParamsAsset";
import useCustomTranslation from "core/customTranslation";
import {translations} from "./translations";
import UnloadsTable from "./UnloadsTable";

const UnloadsContainer = () => {
    const {t: _Tr} = useTranslation("routes");
    const {t: _tC} = useCustomTranslation(translations);
    const title = _Tr("labels.container");
    const {uid} = useParams();
    const unloadsFilters = useRef({});
    const [asset, setAsset] = useState(Asset);
    const [dateRange, setDateRange] = useState(null);
    const [deviceCoords, setDeviceCoords] = useState([]);
    const [unloadsItems, setUnloadsItems] = useState([]);

    const bread = useMemo(() => [
        {name: _Tr("labels.data-view"), url: "/data-view/", current: false},
        {
            name: _Tr("labels.containers"),
            url: "/data-view/containers/",
            current: false,
        },
        {name: title, current: true},
    ]);

    useEffect(() => {
        if (!dateRange && uid) {
            const endDate = new Date();
            const startDate = new Date();
            startDate.setDate(endDate.getDate() - 7);
            setDateRange({startDate, endDate});
            return;
        }
        if (dateRange) {
            let dataSend = {
                uid: uid,
                start: DateUtils.dateToStringInput(dateRange.startDate),
                end: DateUtils.dateToStringInput(dateRange.endDate),
            };
            axiApi.post(`/api/assets/asset/data/uid/`, dataSend).then((resp) => {
                setAsset(resp.data.item);
                setDeviceCoords([...resp.data.item.devices]);
            });
            unloadsFilters.current = {
                uid: uid,
                start: DateUtils.dateToStringInput(dateRange.startDate).split("-").reverse().join("/"),
                end: DateUtils.dateToStringInput(dateRange.endDate).split("-").reverse().join("/"),
            };
            axiApi
                .post("/api/unloads/containers/filter/", unloadsFilters.current)
                .then((resp) => {
                    if (resp.data.items && resp.data.items.length) {
                        const itemsWithUnloads = resp.data.items.map((item) => ({
                            ...item,
                            unloads: item.unloads ? item.unloads : {},
                        }));
                        setUnloadsItems(itemsWithUnloads);
                    } else {
                        setUnloadsItems([]);
                    }
                })
                .catch((err) => {
                    console.error("Error obteniendo unloads:", err);
                    setUnloadsItems([]);
                });
        }
    }, [uid, dateRange]);

    return (
        <>
            <NavBreadcrumb navs={navs} bread={bread} />
            <div className="container-fluid">
                <div className="row">
                    <div className="col-12 preview-canvas offcanvas-header mt-1">
                        <div className="preview-icon">
                            <FontAwesomeIcon icon="trash-can" />
                        </div>
                        <div className="preview-title ps-4">
                            <h5>{title}</h5>
                        </div>
                    </div>
                </div>
                <div className="row">
                    <div className="col-md-8 col-12">
                        <div className="row mb-3">
                            <div className="col-12">
                                <label className="d-inline-block small me-2 text-secondary">UID:</label>
                                <span className="d-inline-block text-black h5">{asset.uid}</span>
                            </div>
                        </div>
                        <ParamsAsset item={asset} dateRange={dateRange} setDateRange={setDateRange} />
                    </div>
                    <div className="col-md-4 col-12">
                        <ConditionalRender
                            condition={asset.lat && asset.lng}
                            fallback={<div className="alert alert-secondary">{_tC("no.coordinates")}</div>}>
                            <div
                                style={{
                                    height: "300px",
                                    borderRadius: "4px",
                                    overflow: "hidden",
                                }}>
                                <MapAssetAndDevicesJS
                                    asset={asset}
                                    devices={deviceCoords}
                                    mapId="map-data-container"
                                    height="300px"
                                    zoom={13}
                                />
                            </div>
                        </ConditionalRender>
                    </div>
                </div>
                <div className="row mb-3">
                    <UnloadsTable
                        itemsShown={unloadsItems}
                        setItemsShown={setUnloadsItems}
                        isLoading={!asset || !asset.uid}
                        filters={unloadsFilters}
                    />
                </div>
            </div>
        </>
    );
};
export default UnloadsContainer;
